"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var NotificationsArea_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsArea = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/layouts/default-layout/component");
const events_1 = require("@front/event/events");
const uuid_1 = require("uuid");
//@ts-ignore                
let rwsTemplate = T.html `<div class="notification-container notification-container-empty">
    ${(0, fast_element_1.repeat)((x, c) => x.notifications, (0, fast_element_1.html) `
    <div @click="${(x, c) => c.parent.removeNotification(c.index)}" class="notification ${x => x.type === 'info' ? 'notification-secondary' : ''}${x => x.type === 'error' ? 'notification-primary' : ''}">
        ${x => x.content.t()}
    </div>
    `)}
</div>`;
require("./styles/layout.scss");
const styles = T.css ``;
const shadowOptions = { "mode": "open" };
let NotificationsArea = NotificationsArea_1 = class NotificationsArea extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.notifications = [];
    }
    static sendNotification(notification) {
        notification.id = (0, uuid_1.v1)();
        component_1.DefaultLayout.emit(events_1.appEvents.notify, notification);
        this.timeouts[notification.id] = setTimeout(() => {
            component_1.DefaultLayout.emit(events_1.appEvents.removeNotifyById, { id: notification.id });
        }, this.timeout);
    }
    removeNotification(index) {
        const id = this.notifications[index].id;
        clearTimeout(NotificationsArea_1.timeouts[id]);
        delete NotificationsArea_1.timeouts[id];
        component_1.DefaultLayout.emit(events_1.appEvents.removeNotify, { index });
    }
};
exports.NotificationsArea = NotificationsArea;
NotificationsArea.timeout = 5000;
NotificationsArea.timeouts = {};
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], NotificationsArea.prototype, "notifications", void 0);
exports.NotificationsArea = NotificationsArea = NotificationsArea_1 = __decorate([
    (0, client_1.RWSView)('notifications-area', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], NotificationsArea);
NotificationsArea.defineComponent();
